module.exports = __webpack_public_path__ + "img/double-arrow-blue.25efe323.svg";